import httpClient from "@/libs/http-client";

// 컴퍼니 정보
export function companyStatistics(data) {
  const url = '/api/super/company/statistics'
  return httpClient.post(url, data).then(response => {
    return response.data
  })
}
// 컴퍼니 회사제어
export function companyOptionSave(data) {
  const url = '/api/super/company/modify/siteSettings'
  return httpClient.post(url, data).then(response => {
    return response.data
  })
}
// 컴퍼니 회원목록
export function superMemberList(data) {
  const url = '/api/super/member/memberList'
  return httpClient.post(url, data).then(response => {
    return response.data
  })
}
// 컴퍼니 등록
export function companyAdd(data) {
  const url = '/api/super/company/addCompany'
  return httpClient.post(url, data).then(response => {
    return response.data
  })
}
// 컴퍼니 등록
export function superRetail(data) {
  const url = '/api/super/retailList'
  return httpClient.post(url, data).then(response => {
    return response.data
  })
}

// 컴퍼니 상세 정보
export function companyDetail(data) {
  const url = '/api/super/company/detail'
  return httpClient.post(url, data).then(response => {
    return response.data
  })
}
// 컴퍼니 상세 정보
export function companyDetail2(data) {
  const url = '/api/super/member/detail'
  return httpClient.post(url, data).then(response => {
    return response.data
  })
}

// 컴퍼니 리스트
export function companyList(data) {
  const url = '/api/admin/partner/list'
  return httpClient.post(url, data).then(response => {
    return response.data
  })
}

// 리테일 리스트
export function retailList(data) {
  const url = '/api/admin/partner/treeList'
  return httpClient.post(url, data).then(response => {
    return response.data
  })

}

//사이트 설정 목록
export function companyOption(params) {
  const url = '/api/admin/setting/option'
  return httpClient.post(url, params).then(response => {
    return response.data
  })
}

// //컴퍼니 트리 목록
export function companyTree(params) {
  const url = '/api/admin/partner/treeList'
  return httpClient.post(url, params).then(response => {
    return response.data
  })
}


export function createOtp(params) {
  const url = '/api/super/makeSiteOtp'
  return httpClient.post(url, params).then(response => {
    return response.data
  })
}

export function getQRCode(params) {
  const url = '/api/super/getSiteOtpUrl'
  return httpClient.post(url, params).then(response => {
    return response.data
  })
}

export function saveGameBet(params) {
  const url = '/api/super/company/modify/gameSettings'
  return httpClient.post(url, params).then(response => {
    return response.data
  })
}

export function saveGameRate(params) {
  const url = '/api/super/company/modify/creditRates'
  return httpClient.post(url, params).then(response => {
    return response.data
  })
}


export function saveMenu(params) {
  const url = '/api/super/company/modify/menuSettings'
  return httpClient.post(url, params).then(response => {
    return response.data
  })
}


export function saveSuperGame(params) {
  const url = '/api/super/company/modify/gameSettings'
  return httpClient.post(url, params).then(response => {
    return response.data
  })
}

export function getVendorRating (data) {
  const url = '/api/admin/partner/getTripleGameRate'
  return httpClient.post(url, data).then(response => {
    return response.data
  })
}

export function setVendorRating (data) {
  const url = '/api/admin/partner/setTripleGameRate'
  return httpClient.post(url, data).then(response => {
    return response.data
  })
}

export function setSiteReset (data) {
  const url = '/api/super/company/reset'
  return httpClient.post(url, data).then(response => {
    return response.data
  })
}

export function tripleConnectionApi (data) {
  const url = '/api/super/company/modify/apiSetting'
  return httpClient.post(url, data).then(response => {
    return response.data
  })
}

export function getSiteIdList (data) {
  const url = '/api/super/company/detail/siteIds'
  return httpClient.post(url, data).then(response => {
    return response.data
  })
}

export function getGameListBySiteId (data) {
  const url = '/api/super/company/detail/siteGameInfo'
  return httpClient.post(url, data).then(response => {
    return response.data
  })
}

export function getMenuListBySiteId (data) {
  const url = '/api/super/company/detail/siteMenuInfo'
  return httpClient.post(url, data).then(response => {
    return response.data
  })
}


export function getOtpUseList (data) {
  const url = '/api/super/company/detail/otpInfo'
  return httpClient.post(url, data).then(response => {
    return response.data
  })
}

export function nexusInfo (data) {
  const url = '/api/super/company/detail/onlyNexus'
  return httpClient.post(url, data).then(response => {
    return response.data
  })
}

export function flexInfo (data) {
  const url = '/api/super/company/detail/onlyFlex'
  return httpClient.post(url, data).then(response => {
    return response.data
  })
}

export function getApiSkinList (data) {
  const url = '/api/super/vendor/nexusSkinInfo'
  return httpClient.post(url, data).then(response => {
    return response.data
  })
}

export function setApiSkin (data) {
  const url = '/api/super/vendor/nexusSkinUpdate'
  return httpClient.post(url, data).then(response => {
    return response.data
  })
}

